module.exports = __webpack_public_path__ + "img/202308_02.cf57bd8d.jpg";